<template>
  <div>
    <van-nav-bar @click-left="clickBack" left-arrow> </van-nav-bar>

    <div style="padding:1rem">
      <van-form @submit="onSubmit" validate-first :show-error="false">
        <van-field
          v-model="phone"
          name="phone"
          label="手机号"
          placeholder="请输入手机号"
          :rules="[
            {
              required: true,
              message: '请填写正确手机号',
              pattern: /^1[3456789]{1}\d{9}$/,
            },
          ]"
        />
        <div style="margin: 2rem 1rem;">
          <van-button round block type="info" native-type="submit">
            提交
          </van-button>
        </div>
      </van-form>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      phone: '',
    }
  },
  methods: {
    clickBack() {
      this.$router.go(-1)
    },
    onSubmit(v) {
      console.log(v)
      this.$https
        .bindPhone({
          userId: this.$store.state.userId,
          ...v,
        })
        .then((res) => {
          if (res.code !== 200) {
            this.$toast(res.msg)
            return false
          }
          let u = JSON.parse(sessionStorage.getItem('userInfo'))
          u.mobile = v.phone
          u.personType = res.data.personType
          sessionStorage.getItem('userInfo', u)
          this.$toast('绑定成功')
          // console.log(res)
        })
        .catch(() => {
          this.$toast('绑定失败')
        })
    },
  },
}
</script>

<style lang="scss" scoped></style>
